import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import { getCurrentMessageUuid } from '../../VNCustomerFacingDisplay/Selectors'
import { checkMessageConfirmation, setCurrentMessage } from '../../VNCustomerFacingDisplay/ActionCreators'
import { bridge_getDeviceModel } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { DEVICE_MODEL } from '../../VNMode/Utils'

export const CFD_MESSAGE_RECEIPT_TIMEOUT = 350

/**
 * CFD (L1400/A3700) messages with confirmation receipts
 */
export const useCFDMessagesWithReceipts = () => {
  const dispatch = useDispatch()
  const currentMessageId = useSelector(getCurrentMessageUuid)

  /**
   * Conditionally generate a unique message UUID for the L1400/A3700
   * The presence of this UUID indicates that the message confirmation feature is enabled
   *
   * @return {String|null} id as UUID4
   */
  const messageUuid = useMemo(() => {
    if (bridge_getDeviceModel() !== DEVICE_MODEL.L1400) return null

    return uuidv4()
  }, [])

  /**
   * Conditionally wait for confirmation of a message receipt
   * This is a ping/pong mechanism to check if the message was received by the L1400/A3700
   *
   * @param {String|null} messageId - The message ID to wait for confirmation
   */
  const waitForConfirmation = useCallback(
    (messageId) => {
      if (!messageId) return

      dispatch(setCurrentMessage(messageId))
      setTimeout(() => dispatch(checkMessageConfirmation()), CFD_MESSAGE_RECEIPT_TIMEOUT)
    },
    [dispatch],
  )

  return {
    currentMessageId,
    messageUuid,
    waitForConfirmation,
  }
}
